"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveVenueOpeningHours = resolveVenueOpeningHours;
const enums_1 = require("../enums");
function hasOpeningHoursData(hours) {
  var _hours$periods, _hours$weekdayDescrip;
  if (!hours) {
    return false;
  }
  if ((_hours$periods = hours.periods) !== null && _hours$periods !== void 0 && _hours$periods.length) {
    return true;
  }
  return Boolean((_hours$weekdayDescrip = hours.weekdayDescriptions) === null || _hours$weekdayDescrip === void 0 ? void 0 : _hours$weekdayDescrip.length);
}
/** Custom hours win over Google when present. */
function resolveVenueOpeningHours(fields) {
  if (hasOpeningHoursData(fields.customOpeningHours)) {
    return {
      openingHours: fields.customOpeningHours,
      openingHoursSource: enums_1.VenueOpeningHoursSource.Custom
    };
  }
  if (hasOpeningHoursData(fields.googleOpeningHours)) {
    return {
      openingHours: fields.googleOpeningHours,
      openingHoursSource: enums_1.VenueOpeningHoursSource.Google
    };
  }
  return {
    openingHours: null,
    openingHoursSource: null
  };
}
//# sourceMappingURL=resolve-venue-opening-hours.js.map